import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, unref as _unref, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_6 = { class: "col-span-12 sm:col-span-6 mb-3" }
const _hoisted_7 = { class: "mt-1 flex rounded-md shadow-sm" }
const _hoisted_8 = { class: "col-span-12 sm:col-span-6 mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = ["aria-checked"]

import { reactive } from 'vue'
import { useRouter } from 'vue-router'

import SelectInput from '@/components/neue/SelectInput'
import { availableMembershipBillingFrequencyOptions } from '@/models/membershipTierTypes'
import api from '@/store/api'


export default {
  __name: 'MembershipTierNew',
  setup(__props) {

const router = useRouter()

const data = reactive({
  tier: {
    name: '',
    description: '',
    type: 'PaidMembershipTier',
    isDefault: '',
    billingFrequency: '',
    membershipPrice: '',
    membershipPriceAsCents: ''
  }
})

// Option Sets
const billingFrequencyOptions = availableMembershipBillingFrequencyOptions

const handleSubmit = () => {
  data.tier.membershipPriceAsCents = data.tier.membershipPrice * 100
  api
    .call('POST', 'membership_tiers', {
      membership_tier: {
        tier_name: data.tier.name,
        type: data.tier.type,
        description: data.tier.description,
        is_default: data.tier.isDefault,
        price_cents: data.tier.membershipPriceAsCents,
        billing_frequency: data.tier.billingFrequency
      }
    })
    .then(response => {
      router.replace(`/store/membership-tiers/${response.data.data.id}`)
    })
}

const handleKeydown = event => {
  // 'Enter' outside textarea
  if (event.keyCode === 13 && event.target.localName !== 'textarea') event.preventDefault()
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_BasicContainer = _resolveComponent("BasicContainer")
  const _component_MainCol = _resolveComponent("MainCol")
  const _component_SideCol = _resolveComponent("SideCol")
  const _component_PageGrid = _resolveComponent("PageGrid")
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: data.tier.name || 'New membership tier'
      }, null, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("form", {
          class: "flex flex-1 flex-col justify-between",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers($event => (handleSubmit()), ["prevent"])),
          onKeydown: [
            _cache[6] || (_cache[6] = _withKeys($event => (handleKeydown($event)), ["enter"])),
            _cache[7] || (_cache[7] = _withKeys(_withModifiers($event => (handleSubmit()), ["meta","exact"]), ["enter"]))
          ]
        }, [
          _createVNode(_component_PageGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_MainCol, null, {
                default: _withCtx(() => [
                  _createVNode(_component_BasicContainer, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", {
                          for: "tier-name",
                          class: "block text-sm font-medium text-gray-700"
                        }, "Name", -1)),
                        _createElementVNode("div", _hoisted_3, [
                          _withDirectives(_createElementVNode("input", {
                            id: "tier-name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((data.tier.name) = $event)),
                            type: "text",
                            name: "tier-name",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          }, null, 512), [
                            [_vModelText, data.tier.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", {
                          for: "tier-description",
                          class: "block text-sm font-medium text-gray-700 mb-1"
                        }, "Description", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "tier-description",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((data.tier.description) = $event)),
                          name: "tier-description",
                          rows: "8",
                          class: "shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                        }, null, 512), [
                          [_vModelText, data.tier.description]
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  false
                    ? _withDirectives((_openBlock(), _createBlock(_component_BasicContainer, { key: 0 }, {
                        default: _withCtx(() => [
                          _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "Pricing", -1)),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _cache[11] || (_cache[11] = _createElementVNode("label", {
                                for: "tier-price",
                                class: "block text-sm font-medium text-gray-700 mb-1"
                              }, "Price", -1)),
                              _createElementVNode("div", _hoisted_7, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm" }, " $ ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  id: "tier-price",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((data.tier.membershipPrice) = $event)),
                                  type: "text",
                                  name: "tier-price",
                                  class: "flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm border-gray-300"
                                }, null, 512), [
                                  [_vModelText, data.tier.membershipPrice]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _cache[12] || (_cache[12] = _createElementVNode("label", {
                                for: "tier-billing-frequency",
                                class: "block text-sm font-medium text-gray-700 mb-1"
                              }, " Billing Frequency ", -1)),
                              _createVNode(_unref(SelectInput), {
                                modelValue: data.tier.billingFrequency,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((data.tier.billingFrequency) = $event)),
                                placeholder: "Select a billing frequency",
                                options: Object.entries(_unref(billingFrequencyOptions)).map(([name, value]) => ({ name, value }))
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 512)), [
                        [_vShow, data.tier.type === 'PaidMembershipTier']
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_SideCol, null, {
                default: _withCtx(() => [
                  _createVNode(_component_BasicContainer, null, {
                    default: _withCtx(() => [
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("span", { class: "text-sm font-medium text-gray-900" }, "Type", -1),
                            _createElementVNode("span", { class: "px-2 capitalize inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-600 text-white" }, " Paid ", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { id: "tier-status" }, [
                          _createElementVNode("span", { class: "text-sm font-medium text-gray-900" }, "Default tier")
                        ], -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass([
                      `relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`,
                      data.tier.isDefault ? 'bg-blue-600' : 'bg-gray-200'
                    ]),
                          role: "switch",
                          "aria-checked": data.tier.isDefault,
                          "aria-labelledby": "tier-status",
                          onClick: _cache[4] || (_cache[4] = $event => (data.tier.isDefault = !data.tier.isDefault))
                        }, [
                          _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: _normalizeClass([
                        `pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`,
                        data.tier.isDefault ? 'translate-x-5' : 'translate-x-0'
                      ])
                          }, null, 2)
                        ], 10, _hoisted_11)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_PageFooter, null, {
            left: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "btn-ghost mr-3",
                to: "/store/membership-tiers"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              })
            ]),
            right: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createElementVNode("button", {
                class: "btn-primary",
                type: "submit"
              }, "Save", -1)
            ]))]),
            _: 1
          })
        ], 544), [
          [_vShow, data.tier]
        ])
      ])
    ]),
    _: 1
  }))
}
}

}